import { css } from "@emotion/react";

import { COLORS } from "../../stylesheets/emotion/vars";
import fontBold from "../font/agrandir-narrow-bold.ttf";
import background from "../images/easy-going/easyGoingBackground.png";

const BORDER_RADIUS = 0.4;

export const easyGoingStyleMultiScreen = css`
    @font-face {
        font-family: "agrandir-bold";
        src: url("${fontBold}");
        font-weight: bold 1;
        font-style: normal;
    }

    body {
        overflow-y: scroll;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
            width: 0;
            height: 0;
        }
    }

    .bannerAll {
        display: grid;
        grid-template-columns: auto auto auto;
        margin-bottom: 1vw;
    }

    .bannerBack {
        width: 18%;
        margin-top: 1.4vw;
        position: absolute;
        margin-left: 55%;
    }

    .bannerFront {
        width: 13.5%;
        margin-left: 33.5%;
        margin-top: 1.4vw;
        position: absolute;
    }

    .bannerLogo {
        width: 7vw;
        position: relative;
        margin-top: 0.3vw;
        margin-bottom: 1.5vw;
        margin-left: 124%;
        z-index: 1000;
    }

    @keyframes rotation {
        0% {
            transform: rotate(0deg) scale(0.5);
            opacity: 0.15;
        }
        5% {
            transform: rotate(180deg) scale(0.5);
            opacity: 0.3;
        }
        10% {
            transform: rotate(360deg) scale(0.5);
            opacity: 0.15;
        }
        100% {
            transform: rotate(360deg) scale(0.5);
            opacity: 0.15;
        }
    }

    @keyframes opacity {
        0% {
            opacity: 0.05;
        }
        50% {
            opacity: 0.2;
        }
        100% {
            opacity: 0.05;
        }
    }

    .menukaart {
        width: 100vw;
        height: 177.78vw; /* 16:9 ratio */
        display: grid;
        grid-template-columns: auto auto auto;
        position: relative;
    }

    .menu {
        max-width: 96vw;
        height: 46.5vw;
        margin-left: 1vw;
        margin-right: 1vw;
        margin-top: 2vw;
        position: relative;
    }

    .backgroundShadow {
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: ${BORDER_RADIUS}vw;
    }

    .info {
        display: flex;
        flex-direction: row-reverse;
    }

    .row {
        display: flex;
        padding-block: 0.5vw;
        padding-top: 0.4vw;
        padding-left: 0.4vw;
        background-color: ${COLORS.easyGoingColor};
    }

    .row:nth-child(even) {
        background-color: ${COLORS.easyGoingSecondaryColor};
    }

    .row:nth-child(odd) {
        background-color: ${COLORS.easyGoingColor};
        border-top-left-radius: ${BORDER_RADIUS}vw;
        border-top-right-radius: ${BORDER_RADIUS}vw;
    }

    .row:nth-last-child(1) {
        border-bottom-left-radius: ${BORDER_RADIUS}vw;
        border-bottom-right-radius: ${BORDER_RADIUS}vw;
    }

    .row:first-child {
        border-top-left-radius: ${BORDER_RADIUS}vw;
        border-top-right-radius: ${BORDER_RADIUS}vw;
    }

    .rowContent {
        padding: 0.22vw 0;
        display: flex;
    }

    .productkind {
        color: white;
        font-size: 0.9vw;
        margin-top: 0.3vw;
        width: 3vw;
        margin-left: 2vw;
    }

    .banner {
        width: 100%;
        margin-left: 8vw;
        margin-top: 1vw;
        position: relative;
    }

    .pagebackground {
        background-image: url("${background}");
        background-repeat: no-repeat;
        background-size: cover;
        width: 100vw;
    }

    .pattern {}

    .redbg {
        position: absolute;
    }

    @font-face {
        font-family: "cordia";
        font-weight: normal;
        font-style: normal;
    }

    .logo {
        display: none;
        position: absolute;
        margin-left: 20%;
        margin-top: -6.5%;
        width: 60%;
        opacity: 0.2;
        animation-delay: 0s;
        animation-iteration-count: infinite;
    }

    .categoryImage {
        display: block;
        min-height: 7.7vw;
        max-height: 7.7vw;
        width: auto;
        object-fit: contain;
        margin-top: 2vw;
        margin-bottom: 0.75vw;
        margin-left: 1.4vw;
        filter: /* brown outline layer */
            brightness(1.1)
            drop-shadow(0.15vw 0 ${COLORS.easyGoingCategoryLogo}) drop-shadow(-0.15vw 0.15vw ${COLORS.easyGoingCategoryLogo}) drop-shadow(0 0.15vw ${COLORS.easyGoingCategoryLogo}) drop-shadow(0 -0.15vw ${COLORS.easyGoingCategoryLogo}) /* white outline layer (extra tight) */ drop-shadow(0.1vw 0 white) drop-shadow(-0.1vw 0.1vw white) drop-shadow(0 0.1vw white) drop-shadow(0 -0.1vw white);
    }

    .marginTopTitle {
        margin-top: -2vw;
    }

    .title {
        margin-left: 1.8vw;
        font-size: 4.5vw;
        font-weight: 600;
        position: relative;
        width: 50vw;
        color: white;
        text-shadow: 1px 1px #000000;
    }

    .titleNotAtTop {
        margin-left: 1.8vw;
        font-size: 4.5vw;
        font-weight: 600;
        margin-top: 3vw;
        position: relative;
        width: 50vw;
        color: white;
        text-shadow: 1px 1px #000000;
    }

    .particles {
        position: absolute;
        margin-left: 50vw;
        width: 300px;
    }

    .btn {
        position: absolute;
    }

    .kindBadge {
        scale: 1.4;
        margin: auto;
        padding: 0 1.5vw;
    }

    .nameStar {
        display: flex;
    }

    .newBadge {
        margin-top: 0.1vw;
        scale: 2;
        transform: translateY(-0.3vw) translateX(0.3vw);
    }

    .nameprice {
        font-size: 2.8vw;
        text-transform: uppercase;
        color: white;
        font-weight: 600;
        margin-top: 0vw;
        padding-block: 0;
    }

    .description {
        font-size: 1.4vw;
        color: ${COLORS.descriptionColor};
        margin: 0 auto;
        display: none;
    }

    .kind {
        font-size: 0.5vw;
        position: relative;
        margin-left: -2vw;
        margin-top: 0.5vw;
        width: 5vw;
        color: white;
    }

    .priceContainer {
        position: relative;
        right: 0.7vw;
        margin-right: 0.2vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: right;
    }

    .price {
        font-size: 2.8vw;
        width: 9vw;
        color: white;
        text-align: right;
    }

    .priceHeader {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        margin-left: -0.55vw;
        font-size: 2.7vw;
        margin-top: -5vw;
        width: 10vw;
        color: white;
        line-height: 0.9;
        margin-bottom: 0.8vw;
    }
    
    .priceHeader .amount {
        font-size: 2.8vw;
        font-weight: 700;
    }

    .priceHeader .unit {
        font-size: 2.6vw;
        text-transform: uppercase;
    }

    .oldPrice {
        font-size: 2.2vw;
        text-shadow: #bfbfa6 0.1vw 0.1vw;
        width: 5.5vw;
        color: grey;
        margin-top: -0.8vw;
        z-index: 1;
        text-decoration: line-through;
    }

    .discountedPrice {
        font-size: 2.8vw;
        text-shadow: #bfbfa6 0.1vw 0.1vw;
        width: 5.5vw;
        margin-top: -0.9vw;
        color: red;
        font-weight: bold;
        z-index: 1;
    }

    .filler {
        flex-grow: 1;
    }

    .svg-inline--fa {
        margin-left: 20px;
        margin-top: 8px;
        font-size: 30px;
    }

    .legendNew {
        display: none;
    }

    .priceGrid {
        display: flex;
        justify-content: center;
        margin-right: 1vw;
    }

    .legend {
        position: absolute;
        bottom: -118.9vw;
        right: -3vw;
        width: 59vw;
        .container {
            width: 100%;
            .content {
                display: flex;
                background-color: ${COLORS.pricelistTableContainer};
                border-radius: 1vw;
                flex-grow: 1;
                justify-content: center;
                .legendBadge {
                    height: 3vw;
                }
                .legendRow {
                    margin-top: 0.4vw;
                    margin-bottom: 0.3vw;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    padding-right: 1.75vw;
                    .newIcon {
                        margin-right: 0.4vw;
                        scale: 1.3;
                        transform: translateY(-0.3vw) translateX(0.3vw);
                    }
                    .label {
                        padding-left: 1vw;
                        font-size: 2vw;
                        color: ${COLORS.legendTextColor};
                    }
                }
            }
        }
`;
